import * as THREE from 'three';

import { eventBus } from '@/hooks/useEventBus';

class Game {
  constructor(collectibleAssets, collect_asset, time = 60) {
    this.collectibleAssets = collectibleAssets;
    this.collect_asset = collect_asset;
    this.timeinterval;
    this.collectible_timeinterval;
    this.score = 0;
    this.time = time;
    this.collectibleAssetIds = [];
    this.audioManager = {};
  }

  initAudioManager() {
    let collectSound = document.querySelector('#collectsound').components.sound;
    this.audioManager = {
      collect_sound: collectSound,
    };
  }
  initCollectElement = () => {
    const collectElement = document.createElement('a-image');
    const attributes = {
      id: 'collect',
      src: this.collect_asset?.uri + '?008484',
      scale: '1 1 10',
      // shadow: 'cast: true',
      position: '0 0 -3',
      rotation: '0 0 0',
      'static-body': 'shape: box;',
      // 'follow-camera': '',
    };
    for (const key in attributes) {
      collectElement.setAttribute(key, attributes[key]);
    }
    const scene = document.querySelector('a-scene');
    const camera = document.getElementById('camera');

    // Add touch move controls for left/right movement
    function moveTouch(e) {
      e.preventDefault();

      // Get screen dimensions
      const screenWidth = window.innerWidth;

      // Get touch X position
      const touchX = e.touches[0].clientX;

      // Normalize to -1 to 1 range (center at 0)
      const normalizedX = (touchX / screenWidth) * 2 - 1;

      // Get camera position and FOV to calculate world space bounds
      const cameraPos = camera.getAttribute('position');
      const fov = camera.getAttribute('camera')?.fov || 80;
      const collectorZ = -3; // Z position of collector
      const zDistance = Math.abs(cameraPos.z - collectorZ);

      // Calculate visible width at the collector's Z position
      const fovRadians = (fov * Math.PI) / 180;
      const visibleHeight = 2 * zDistance * Math.tan(fovRadians / 2);
      const aspect = screenWidth / window.innerHeight;
      const visibleWidth = visibleHeight * aspect;

      // Map normalized coordinate to world space
      const worldX = normalizedX * (visibleWidth / 2);

      // Clamp to prevent going too far off screen (with padding)
      const clampedX = Math.max(
        -(visibleWidth / 2) + 1,
        Math.min(visibleWidth / 2 - 1, worldX)
      );

      // Update collector position
      const currentPos = collectElement.getAttribute('position');
      collectElement.setAttribute('position', {
        x: cameraPos.x + clampedX,
        y: currentPos.y,
        z: currentPos.z,
      });
    }

    scene.addEventListener('touchmove', moveTouch, { passive: false });

    if (scene) scene.appendChild(collectElement);
  };

  initAssets = () => {
    return new Promise(resolve => {
      if (this.collectibleAssets && this.collectibleAssets.length > 0) {
        let loadedCount = 0;
        const totalImages = this.collectibleAssets.length;

        this.collectibleAssets.forEach((ele, i) => {
          const img = document.createElement('img');
          img.crossOrigin = 'anonymous';

          img.onload = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              resolve();
            }
          };

          img.onerror = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              resolve();
            }
          };

          img.src = ele.uri;
          let id = `collectibe_${i + 1}`;
          img.id = id;
          this.collectibleAssetIds.push(id);
          const assetsEnt = document.querySelector('a-assets');
          if (assetsEnt) assetsEnt.appendChild(img);
        });
      } else {
        resolve();
      }
    });
  };
  initGroundElement = () => {
    const element = document.createElement('a-box');
    const attributes = {
      id: 'ground',

      scale: '100 1 100',
      position: '0 -5 0',
      rotation: '0 0 0',
      material: 'transparent:true; opacity:0',
      'static-body': 'shape: box;',
    };
    for (const key in attributes) {
      element.setAttribute(key, attributes[key]);
    }

    const scene = document.querySelector('a-scene');
    if (scene) scene.appendChild(element);
  };

  spawnCollectibleElement() {
    const obstacle = [-2, -1, 0, 1, 1.5, 2, 2.5];
    const random = Math.floor(Math.random() * obstacle.length);
    const spawnloc = new THREE.Vector3(obstacle[random], 8, -3);
    const element = document.createElement('a-image');
    const randomAssetID =
      this.collectibleAssetIds[
        Math.floor(Math.random() * this.collectibleAssetIds.length)
      ];
    const attributes = {
      id: 'collectible',
      src: `#${randomAssetID}`,
      scale: '0.8 0.8 10',
      position: spawnloc,
      material: 'transparent: true; opacity: 1',
      rotation: '0 0 0',
    };
    for (const key in attributes) {
      element.setAttribute(key, attributes[key]);
    }
    element.setAttribute('body', {
      type: 'dynamic',
      sphereRadius: 0.6,
      shape: 'sphere',
    });
    const scene = document.querySelector('a-scene');
    if (scene) {
      scene.appendChild(element);
    }
    element.addEventListener('collide', e => {
      if (e.detail.body.el.id == 'collect') {
        this.score = this.score + 10;
        if (this.audioManager.collect_sound) {
          this.audioManager.collect_sound.stopSound();
          this.audioManager.collect_sound.playSound();
        }
        const scoreEl = document.getElementById('score');
        if (scoreEl) scoreEl.innerText = this.score;
      }

      setTimeout(() => {
        e.detail.body.el.parentNode.removeChild(e.detail.body.el);
      }, 0);
    });
  }
  handleMoveCollectElement() {
    const scene = document.querySelector('a-scene');
    const collectmodel = document.getElementById('collect');
    const camera = document.querySelector('[camera]');

    function moveTouch(e) {
      e.preventDefault();

      // Get screen dimensions
      const screenWidth = window.innerWidth;

      // Get touch X position
      const touchX = e.touches[0].clientX;

      // Normalize to -1 to 1 range (center at 0)
      const normalizedX = (touchX / screenWidth) * 2 - 1;

      // Get camera position and FOV to calculate world space bounds
      const cameraEl = camera || scene.querySelector('a-camera');
      const cameraPos = cameraEl.getAttribute('position');
      const fov = cameraEl.getAttribute('camera')?.fov || 80;
      const zDistance = Math.abs(cameraPos.z - -3); // Distance from camera to collector

      // Calculate visible width at the collector's Z position
      const fovRadians = (fov * Math.PI) / 180;
      const visibleHeight = 2 * zDistance * Math.tan(fovRadians / 2);
      const aspect = screenWidth / window.innerHeight;
      const visibleWidth = visibleHeight * aspect;

      // Map normalized coordinate to world space
      const worldX = normalizedX * (visibleWidth / 2);

      // Clamp to prevent going too far off screen
      const clampedX = Math.max(-6, Math.min(6, worldX));

      var pos = new THREE.Vector3(clampedX, 0, -3);
      collectmodel.setAttribute('position', pos);
    }

    scene.addEventListener('touchmove', moveTouch, { passive: false });
  }
  startTimer() {
    if (this.time <= 0) {
      this.gameOver();
      return;
    }
    this.time = this.time - 1;
    const timeEle = document.getElementById('timer');
    if (timeEle) timeEle.innerText = this.time;
  }
  async gameStart() {
    this.initAudioManager();
    await this.initAssets();
    this.initCollectElement();

    this.handleMoveCollectElement();
    this.initGroundElement();
    this.collectible_timeinterval = setInterval(() => {
      this.spawnCollectibleElement();
    }, 2000);
    this.timeinterval = setInterval(() => {
      this.startTimer();
    }, 1000);

    // setTimeout(() => {
    //   this.initGroundElement();
    // }, 0);
  }
  gameOver() {
    eventBus.emit('game_over', { score: this.score });

    clearInterval(this.collectible_timeinterval);
    clearInterval(this.timeinterval);
  }
}

export default Game;
